<div class="header-search sticky">
  <mat-form-field subscriptSizing="dynamic" class="search">
    <input
      matInput
      placeholder="Search layers..."
      [(ngModel)]="search$"
      (ngModelChange)="search$.set($event)"
    />
    <button
      matIconButton
      matSuffix
      (click)="clearSearch()"
      aria-label="Clear search"
      matTooltip="Clear search"
    >
      <mat-icon>clear</mat-icon>
    </button>
  </mat-form-field>
  <button
    matIconButton
    class="icon-button-warn clear-layers"
    (click)="unselectAllLayers()"
    matTooltip="Unselect all layers"
  >
    <mat-icon fontIcon="layers_clear"></mat-icon>
  </button>
</div>

<div class="content-container">
  @let titlesState = availableGeoserverLayerListTitlesState$();
  @if (titlesState.status === 'loading') {
    <div class="spinner-container">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  } @else if (titlesState.status === 'error') {
    <p class="no-data">
      No layer available. <br />
      Please, try again later.
    </p>
  } @else if (filteredLayers$()) {
    @if (isConnected) {
      @if (filteredLayers$().length == availableLayers$().length) {
        <app-personal-layers></app-personal-layers>
        <app-shared-layers></app-shared-layers>
      } @else if (filteredPersonalLayers$().length > 0 || filteredSharedLayers$().length > 0) {
        @if (search$() !== '' && filteredPersonalLayers$().length > 0) {
          <app-personal-layers></app-personal-layers>
        }
        @if (search$() !== '' && filteredSharedLayers$().length > 0) {
          <app-shared-layers></app-shared-layers>
        }
      }
      @if (
        filteredLayers$().length == 0 &&
        filteredPersonalLayers$().length == 0 &&
        filteredSharedLayers$().length == 0
      ) {
        <p class="no-data-info">No results for this search.</p>
      }
    }
    @for (category of categories$(); track $index) {
      @if (
        category.name != '' && (filteredLayers$() | filterLayerOnCategory: category).length > 0
      ) {
        <mat-accordion>
          <!-- Put mat-accordion marker outside the for to have only 1 category at once -->
          <mat-expansion-panel
            [expanded]="category.expanded"
            (opened)="category.expanded = true"
            (closed)="category.expanded = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ category.name }}
              </mat-panel-title>
              <!-- <mat-panel-description> Something can be useful here, like number of layers selected / total with update at searching</mat-panel-description> -->
            </mat-expansion-panel-header>
            <div class="layers-list">
              @for (layer of filteredLayers$() | filterLayerOnCategory: category; track $index) {
                <app-card-layer-standard [layer]="layer"></app-card-layer-standard>
              }
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      }
    }
  }
</div>
